export const LoadingComponent = () => {
    return (
        <div className="h-full w-full bg-gray-600 bg-opacity-80 flex absolute flex-col justify-center top-0 right-0">
         <div className="lds-spinner m-auto"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
    )
}